import React from 'react'
import { Button, Modal, ModalBody, ModalFooter, ModalHeader } from 'reactstrap'
import { EditOrderAction, useEditOrderSvc } from '../service'

import { useForm } from 'react-hook-form'

export function EditOrderType(props: { onClose: () => void; onSave: (action: EditOrderAction) => void }): JSX.Element {
  const editOrderSvc = useEditOrderSvc()
  const orderTypes = editOrderSvc.getAvailableServices()
  const prevService = editOrderSvc.getOrderType()

  const form = useForm({
    mode: 'onBlur',
    defaultValues: {
      order_type: editOrderSvc.getOrderType().id
    },
  })

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = form

  const validateAndSave = (data: any) => {
    props.onSave({
      op: 'update-order_type',
      value: data.order_type,
      label: orderTypes.find(t => t.id == data.order_type)?.label || data.order_type,
      prev_value: prevService.id,
      prev_label: prevService.label
    })
    props.onClose()
  }

  return (
    <Modal isOpen={true} onClosed={props.onClose}>
      <ModalHeader>
        <span>Change Service Type</span>
      </ModalHeader>
      <form className="form-horizontal" onSubmit={handleSubmit(validateAndSave)}>
        <ModalBody>
          <div className="form-group">
            <label htmlFor="value">Available restaurant services:</label>
            <select
              id="value"
              className="form-control input input-small"
              style={errors && errors.order_type ? { color: 'red' } : {}}
              {...register('order_type', {
                validate: {
                  required: (value) => !value ? 'Service is required' : true,
                  isChanged: (value) => value == prevService.id ? 'Please select a different service' : true,
                  notAvailable: (value) => value == 'DELIVERY' ? 'Delivery is not accepted' : true,
                },
              })}
            >
              {orderTypes.map(({ id, label }) => <option value={id} key={id}>{label}</option>)}
            </select>
            {errors && errors.order_type && <span className="text-danger">{errors.order_type.message}</span>}
          </div>
        </ModalBody>
        <ModalFooter>
          <Button type="submit" color="primary">Save</Button>
          <Button color="secondary" onClick={props.onClose}>
            Cancel
          </Button>
        </ModalFooter>
      </form>
    </Modal>
  )
}
